import { useState,useEffect } from "react";
import axios from "axios";

const API_URL=
process.env.REACT_APP_API_URL;

console.log(
"API URL:",
API_URL
);

function Login() {

const [email,setEmail]=useState("");
const [password,setPassword]=useState("");

const [username,setUsername]=useState("");
const [regEmail,setRegEmail]=useState("");
const [regPassword,setRegPassword]=useState("");

const [companyName,setCompanyName]=useState("");
const [contactPerson,setContactPerson]=useState("");
const [mobile,setMobile]=useState("");
const [city,setCity]=useState("");

const [num1,setNum1]=useState(0);
const [num2,setNum2]=useState(0);
const [captcha,setCaptcha]=useState("");

const [showForgot,setShowForgot]=useState(false);

const [forgotEmail,setForgotEmail]=useState("");

useEffect(()=>{

generateCaptcha();

},[]);

const generateCaptcha=()=>{

const a=Math.floor(
Math.random()*10
);

const b=Math.floor(
Math.random()*10
);

setNum1(a);
setNum2(b);

};

const handleLogin=async(e)=>{

e.preventDefault();

try{

const response=
await axios.post(

`${API_URL}/login.php`,

{
email,
password
}

);

if(response.data.status){

localStorage.setItem(
"token",
response.data.token
);

localStorage.setItem(
"role_id",
response.data.user.role_id
);

localStorage.setItem(
"username",
response.data.user.username
);

localStorage.setItem(
"email",
response.data.user.email
);

localStorage.setItem(
"client_id",
response.data.user.client_id
);

window.location.reload();

}
else{

alert(
response.data.message
);

}

}
catch(error){

console.log(error);

}

};

const registerClient=async(e)=>{

e.preventDefault();

if(
parseInt(captcha)!==
(num1+num2)
){

alert(
"Captcha incorrect"
);

generateCaptcha();

return;

}

try{

const response=
await axios.post(

`${API_URL}/Client/self-register.php`,

{
username,
email:regEmail,
password:regPassword,
company_name:companyName,
contact_person:contactPerson,
mobile,
city
}

);

if(
response.data.status
){

alert(
"Registration Successful"
);

window.location.reload();

}
else{

alert(
response.data.message
);

}

}
catch(error){

console.log(error);

}

};

return(

<div className="container mt-5">

<div className="row">

<div className="col-md-5">

<div className="card shadow">

<div className="card-body">

<h4 className="mb-4">

Login

</h4>

<form onSubmit={handleLogin}>

<input
type="email"
className="form-control mb-3"
placeholder="Email"
value={email}
onChange={(e)=>
setEmail(
e.target.value
)}
/>

<input
type="password"
className="form-control mb-3"
placeholder="Password"
value={password}
onChange={(e)=>
setPassword(
e.target.value
)}
/>

<button
className="btn btn-primary w-100"
>

Login

</button>

<div className="text-center mt-2">

<button
type="button"
className="btn btn-link p-0"
onClick={()=>
setShowForgot(true)
}
>

Forgot Password?

</button>

</div>

</form>

</div>

</div>

</div>

<div className="col-md-7">

<div className="card shadow">

<div className="card-body">

<h4 className="mb-4">

Client Registration

</h4>

<form
onSubmit={registerClient}
>

<div className="row">

<div className="col-md-6 mb-2">

<input
className="form-control"
placeholder="Username"
value={username}
onChange={(e)=>
setUsername(e.target.value)
}
/>

</div>

<div className="col-md-6 mb-2">

<input
className="form-control"
placeholder="Email"
value={regEmail}
onChange={(e)=>
setRegEmail(e.target.value)
}
/>

</div>

<div className="col-md-6 mb-2">

<input
type="password"
className="form-control"
placeholder="Password"
value={regPassword}
onChange={(e)=>
setRegPassword(e.target.value)
}
/>

</div>

<div className="col-md-6 mb-2">

<input
className="form-control"
placeholder="Company"
value={companyName}
onChange={(e)=>
setCompanyName(e.target.value)
}
/>

</div>

<div className="col-md-6 mb-2">

<input
className="form-control"
placeholder="Contact Person"
value={contactPerson}
onChange={(e)=>
setContactPerson(e.target.value)
}
/>

</div>

<div className="col-md-6 mb-2">

<input
className="form-control"
placeholder="Mobile"
value={mobile}
onChange={(e)=>
setMobile(e.target.value)
}
/>

</div>

<div className="col-md-6 mb-2">

<input
className="form-control"
placeholder="City"
value={city}
onChange={(e)=>
setCity(e.target.value)
}
/>

</div>

<div className="col-md-6">

<div className="input-group">

<span className="input-group-text">

{num1}+{num2}=

</span>

<input
className="form-control"
placeholder="Captcha"
value={captcha}
onChange={(e)=>
setCaptcha(e.target.value)
}
/>

</div>

</div>

</div>

<button
className="btn btn-success mt-3 w-100"
>

Register

</button>

</form>

</div>

</div>

</div>

</div>

</div>

);

}

export default Login;